export const DOCUMENTO = () => `/documento`;
export const DOCUMENTO_EDIT = () => `/documento/edit`;
